module.exports = __webpack_public_path__ + "media/images/weather/81_night-01d46036c3b6c7127a1c8b7c9aa8b640.png";